import { executeRequest, Request } from '@jfs/network'
import { actionMenuStrings } from '../data/static/strings'
import { RootStore } from '../data/store'
import { updateEndDateTimeInRequest } from '../util/util'
import { settlementParser } from './../network/parsers/SettlementParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = settlementParser(data?.data)
  return respData
}

const getSettlementSummary = (req: any, tokens: any, userAccessToken: string, isCustomFromRecent = false, abortController?: any) => {
  const isCustomRange = RootStore.settlements.selectedDateInfo.dateLabel === actionMenuStrings.customDate
  //|| RootStore.settlements.selectedDateInfo.dateLabel === actionMenuStrings.yesterday
  const request: Request<{}> = {
    config: sitConfig(tokens, abortController),
    apiPath: APIEndPoints.Settlements,
    method: 'POST',
    body:
      isCustomRange || isCustomFromRecent
        ? req
        : updateEndDateTimeInRequest(req, RootStore.settlements.selectedDateInfo),
    headers: {
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data?.data)
  })
}

export { getSettlementSummary }
